import { IRequestConnection } from '@r1-frontend/api-domru/api-request/v2/managing-connection-request/check-exist/dto/IRequestConnection';

import { IWidgetBtn, IWidgetItem } from '~/src/features/lk/orders/ConnectionRequests/RequestWidget';
import { InferValueTypes } from '~/src/store';

import * as actionCreators from './actions';

export const actionTypes = {
    INITIALIZED: '@LK/CONNECTION_ORDERS/INITIALIZED',
    CLEAR_DATA: '@LK/CONNECTION_ORDERS/CLEAR_DATA',
    SET_LOADING: '@LK/CONNECTION_ORDERS/SET_LOADING',
    SET_ERROR: '@LK/CONNECTION_ORDERS/SET_ERROR',
} as const;

export type TActions = ReturnType<InferValueTypes<typeof actionCreators>>;

const reducer = (state: IInitialState = initialState, action: TActions): IInitialState => {
    switch (action.type) {
        case actionTypes.SET_LOADING: {
            return {
                ...initialState,
                loadingStatus: ELoadingStatus.loading,
            };
        }
        case actionTypes.INITIALIZED: {
            return {
                ...initialState,
                ...action.payload,
                loadingStatus: ELoadingStatus.success,
            };
        }
        case actionTypes.SET_ERROR: {
            return {
                ...initialState,
                loadingStatus: ELoadingStatus.error,
                error: action.payload,
            };
        }
        case actionTypes.CLEAR_DATA: {
            return {
                ...initialState,
            };
        }
        default: {
            const unknownAction: never = action;
            return state || unknownAction;
        }
    }
};

export enum ELoadingStatus {
    notInit,
    loading,
    success,
    error,
}

export interface IImage {
    imageSrc: string,
    imageAlt: string,
    imageBg?: string,
    channelCount?: number,
    textForImage?: string,
    bgForImage?: string,
}

export interface IProductItem {
    id: number,
    title: string,
    description: string,
    icon: IImage | null,
}

export interface IConnectionRequestWithProducts extends IRequestConnection {
    productItems: IProductItem[],
}

export interface IInitialState {
    loadingStatus: ELoadingStatus,
    popupTitle: string,
    connectPrice: number,
    requestItems: IConnectionRequestWithProducts[],
    widgetItems: IWidgetItem[],
    btns: IWidgetBtn[],
    error: string,
}

export const initialState: IInitialState = {
    loadingStatus: ELoadingStatus.notInit,
    popupTitle: '',
    connectPrice: 0,
    requestItems: [],
    widgetItems: [],
    btns: [],
    error: '',
};

export default reducer;
